import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import ContactModel from 'donor-elf-web/models/contact';
import type { ContactPhoneEmailItem } from 'donor-elf-web/models/contact';
import { on } from '@ember/modifier';
import { fn } from '@ember/helper';
import { notEq } from 'ember-truth-helpers';
import MergeContactsSection from 'donor-elf-web/components/add-something-modal/merge-contacts/section';
import FormUnderlineLabel from 'donor-elf-web/components/form/underline/label';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

interface ComponentArgs {
  changeset: any;
  contactToKeep: ContactModel;
  contactToMerge: ContactModel;
  property: 'phones' | 'emails';
}

export default class AddSomethingModalMergeContactsMergePhonesOrEmailsComponent extends Component<ComponentArgs> {
  constructor(owner: unknown, args: ComponentArgs) {
    super(owner, args);
    // merge items and remove duplicates
    this.itemsToKeep = [...this.contactToKeepItems, ...this.contactToMergeItems].filter(
      (item, index, self) => self.findIndex(i => i.v === item.v) === index
    );
    setTimeout(() => {
      this.args.changeset.set(this.args.property, { data: this.itemsToKeep });
    });
  }

  @tracked itemsToKeep: ContactPhoneEmailItem[] = [];

  get heading() {
    return this.args.property === 'phones' ? 'Phones' : 'Emails';
  }

  get itemHeading() {
    return this.args.property === 'phones' ? 'Phone' : 'Email';
  }

  handleInputOnItemValue(item: ContactPhoneEmailItem, event: any) {
    item.v = event.target.value;
  }

  handleInputOnItemLabel(item: ContactPhoneEmailItem, event: any) {
    item.l = event.target.value;
  }

  deleteItem = (item: ContactPhoneEmailItem) => {
    this.itemsToKeep = this.itemsToKeep.filter(i => i !== item);
    this.args.changeset.set(this.args.property, { data: this.itemsToKeep });
  };

  get contactToKeepItems() {
    return this.args.contactToKeep[this.args.property]?.data || [];
  }

  get contactToMergeItems() {
    return this.args.contactToMerge[this.args.property]?.data || [];
  }

  <template>
    <div ...attributes>
      <MergeContactsSection
        @header={{this.heading}}
      >
        <div class='py-1'>
          <div class='row'>
            <div class='col'>
              {{#each this.itemsToKeep as |item index|}}
                <div class='d-flex {{if (notEq index 0) 'mt-3'}}'>
                  <div class='tw-w-1 bg-brand mr-2 flex-shrink-0'></div>
                  <div class='flex-grow-1'>
                    <FormUnderlineLabel
                      @label={{this.itemHeading}}
                      class='mb-2'
                    >
                      <input
                        value={{item.v}}
                        class='form-underline-input w-100'
                        {{on 'input' (fn this.handleInputOnItemValue item)}}
                      />
                    </FormUnderlineLabel>
                    <FormUnderlineLabel
                      @label='Label (optional)'
                    >
                      <input
                        value={{item.l}}
                        class='form-underline-input w-100'
                        {{on 'input' (fn this.handleInputOnItemLabel item)}}
                      />
                    </FormUnderlineLabel>
                  </div>
                  <div>
                    <button
                      {{on 'click' (fn this.deleteItem item)}}
                      class='btn btn-sm btn-link icon-link-danger pr-0 pl-2 mt-2_5'
                      type='button'
                    >
                      {{svgJar 'trash'}}
                    </button>
                  </div>
                </div>
              {{/each}}
            </div>
            <div class='col'>
              <FormUnderlineLabel @label='Contact to Keep'>
                {{#each this.contactToKeepItems as |item|}}
                  <div class='ml-2'>
                    <div class='font-weight-light tw-text-xs -tw-mb-px text-muted'>
                      {{item.l}}
                    </div>
                    <div>{{item.v}}</div>
                  </div>
                {{/each}}
              </FormUnderlineLabel>
              <FormUnderlineLabel @label='Contact to Merge' class='mt-3'>
                {{#each this.contactToMergeItems as |item|}}
                  <div class='ml-2'>
                    <div class='font-weight-light tw-text-xs -tw-mb-px text-muted'>
                      {{item.l}}
                    </div>
                    <div>{{item.v}}</div>
                  </div>
                {{/each}}
              </FormUnderlineLabel>
            </div>
          </div>
        </div>
      </MergeContactsSection>
    </div>
  </template>
}
